<div class="otpContainer ">
   
    <mat-card class="mat-elevation-z2" [ngClass]="{'loginCard ': !(isHandset$ | async) , 'loginCardHandset': (isHandset$ | async) }" >
     
      <form id="formContainer"  [formGroup]="loginForm" >
        <div  [ngClass]="{'headerImageWeb': !(isHandset$ | async) , 'headerImageHandset': (isHandset$ | async) }" class="headerFlex" >
          <img src="assets/logo.png" alt="mdr logo" >
       </div>
       <div style="display: flex; color: #000000; opacity: 0.8; padding-top: 20px;" class="mat-display-4">
        Vanuatu Medical Disability Registry
       </div>
       <div  class="mat-subheading-1" style="color: #000000;  opacity: 0.8; padding-top: 24px;" >
        Enter the OTP we sent to 
       </div>
       <div  class="mat-subheading-1" style="padding-top: 4px;">
         {{this.mobileNumber}}
       </div>
       <div style="padding-top: 36px;">
        <ngx-otp-input [config]="otpInputConfig" [status] = "errorStatus" (otpChange)="handeOtpChange($event)" (fill)="handleFillEvent($event)">
        </ngx-otp-input>
       </div>
       <div style="color:#006C4C;padding-top: 16px;" class="mat-headline" *ngIf="counter != 0">{{transform(counter)}}</div>
       <div class="action-area" style="padding-top: 16px;" *ngIf="counter == 0">
        <button  (click)="onResend()" mat-raised-button style="background-color: #7E9689;"> <span style="color: #000000; opacity: 0.87;">RESEND OTP</span> </button>
      </div>
       <div class="action-area" style="padding-top: 16px;">
        <button  (click)="onVerify()" mat-raised-button [ngClass]="{'verify-btn': !this.otp ,'verify-btn-disabled':isOtp}"  [disabled]="isOtp"> 
            <span [ngClass]="{'verify-btn': !this.otp ,'verify-btn-disabled':isOtp}">VERIFY</span> 
        </button>
      </div>
      <div style="padding-top: 12px;"><span class="mat-body-2 back"  (click)="back()">BACK</span></div>
    </form>
    </mat-card> 
    </div>